import { TransformInt } from '../../../shared/decorators/transform-int.decorator';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { ProtoContactDto } from '../../contacts/dtos/proto-contact.dto';
import { ProtoDriverDto } from '../../drivers/dtos/proto-driver.dto';
import { AccountTypeEnum } from '../enums/account-type.enum';

/**
 * Body a signed-in person sends to change their proto account.
 * The sign-in email stays on the stored contact.
 */
export class UpdateAccountDto {
  @TransformInt()
  id!: number;

  type!: AccountTypeEnum;

  color?: string | null;

  notes?: string | null;

  contact?: ProtoContactDto | null;

  driver?: ProtoDriverDto | null;

  files?: FileDto[] | null;
}
